/** @jsx isolateComponent */

import { Fragment } from 'react';

import { isolateComponent } from '@zapier/common-utils';
import { Margin, Text } from '@zapier/design-system';

type Props = {
  tasks: number;
};

export const ReducedTaskTeamOfferModalView = ({ tasks }: Props) => (
  <Fragment>
    <Text tag="h1" textAlign="center" type="header800">
      Upgrade to Zapier for Teams
    </Text>

    <Margin margin="20px 0">
      <Text tag="p" textAlign="center" type="bodyText900">
        Get all the features of our Team plan—such as unlimited users, shared
        app connections, and {tasks.toLocaleString()} Tasks per month—for a
        lower price.
      </Text>
    </Margin>
  </Fragment>
);
